import { createGuid } from '../utils/Guid';
export class FriendlyNameService {
    /***
     * Generates random identifier (GUID like) that is valid for usage by the Krpano.
     */
    static generateRandomId() {
        return this.getFriendlyName(createGuid());
    }
    static getFriendlyName(hotspotId) {
        return `hotspot_${hotspotId.replace(/-/gim, '')}`;
    }
    static fromFriendlyName(hotspotId) {
        return hotspotId.replace('hotspot_', '');
    }
    static combine(id1, id2) {
        return (id1 + id2);
    }
}
